import { AsyncPipe, SlicePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { catchError, map, Observable, of, startWith } from 'rxjs';

import { Ga4AnalyticsService } from '../../../core/analytics/ga4-analytics.service';
import { TopicApiModel } from '../models/topic.model';
import { TopicsService } from '../services/topics.service';

interface TopicsPageViewModel {
  topics: TopicApiModel[];
  isLoading: boolean;
  isEmpty: boolean;
  hasError: boolean;
}

@Component({
  selector: 'app-topics-page',
  imports: [AsyncPipe, SlicePipe],
  templateUrl: './topics-page.component.html',
})
export class TopicsPageComponent {
  private readonly ga4AnalyticsService = inject(Ga4AnalyticsService);
  private readonly title = inject(Title);
  private readonly topicsService = inject(TopicsService);

  protected readonly vm$: Observable<TopicsPageViewModel> = this.topicsService.getTopics().pipe(
    map((topics) => ({
      topics,
      isLoading: false,
      isEmpty: topics.length === 0,
      hasError: false,
    })),
    catchError(() =>
      of({
        topics: [],
        isLoading: false,
        isEmpty: false,
        hasError: true,
      }),
    ),
    startWith({
      topics: [],
      isLoading: true,
      isEmpty: false,
      hasError: false,
    }),
  );

  public constructor() {
    this.title.setTitle('Topics');
    this.ga4AnalyticsService.trackPageView();
  }

  protected topicHref(topicId: string): string {
    return `/numerons/bytopic/${topicId}`;
  }

  protected categoryHref(category: string): string {
    return `/numerons/bycategory/${encodeURIComponent(category)}`;
  }
}
